import { render, staticRenderFns } from "./AboutEESTEC.vue?vue&type=template&id=d85d65c2&scoped=true&"
import script from "./AboutEESTEC.vue?vue&type=script&lang=js&"
export * from "./AboutEESTEC.vue?vue&type=script&lang=js&"
import style0 from "./AboutEESTEC.vue?vue&type=style&index=0&id=d85d65c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85d65c2",
  null
  
)

export default component.exports